import React, { useEffect, useState } from 'react';
import { users as usersAPI } from '../api';
import { B } from '../constants';

// Find travellers by @username or name and follow them from the Reels screen.
export default function UserSearchPanel({ user, onAuthRequired, onFollowChange }) {
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busyId, setBusyId] = useState(null);

  useEffect(() => {
    const term = q.trim().replace(/^@+/, '');
    if (term.length < 2) { setResults([]); setLoading(false); return undefined; }
    let active = true;
    setLoading(true);
    const t = setTimeout(() => {
      usersAPI.search(term)
        .then(data => { if (active) setResults(data?.users || []); })
        .catch(() => { if (active) setResults([]); })
        .finally(() => { if (active) setLoading(false); });
    }, 300);
    return () => { active = false; clearTimeout(t); };
  }, [q]);

  const toggleFollow = async (target) => {
    if (!user) { onAuthRequired?.(); return; }
    setBusyId(target.id);
    try {
      if (target.isFollowing) await usersAPI.unfollow(target.id);
      else await usersAPI.follow(target.id);
      const next = !target.isFollowing;
      setResults(prev => prev.map(u => (u.id === target.id
        ? { ...u, isFollowing: next, followersCount: Math.max(0, (u.followersCount || 0) + (next ? 1 : -1)) }
        : u)));
      onFollowChange?.(target.id, next);
    } catch {
      // leave the button as it was
    } finally {
      setBusyId(null);
    }
  };

  const term = q.trim().replace(/^@+/, '');

  return (
    <div className="reels-user-search" style={{ marginBottom: 16 }}>
      <div style={{ position: 'relative' }}>
        <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', fontSize: 15 }}>👤</span>
        <input type="search" aria-label="Search people" placeholder="Find travellers by @username or name"
          value={q} onChange={e => setQ(e.target.value)}
          style={{ width: '100%', padding: '10px 16px 10px 40px', borderRadius: 50, border: '1px solid var(--reels-border, #e5e0d8)', background: 'var(--reels-panel-bg, white)', color: 'var(--reels-fg, inherit)', fontFamily: "'Montserrat',sans-serif", fontSize: 13, outline: 'none', boxSizing: 'border-box' }} />
      </div>
      {term.length >= 2 && (
        <div role="list" style={{ marginTop: 8, borderRadius: 14, border: '1px solid var(--reels-border, #e5e0d8)', background: 'var(--reels-panel-bg, white)', maxHeight: 320, overflowY: 'auto' }}>
          {loading && <div style={{ padding: 14, fontSize: 13, color: 'var(--reels-muted, #5b6470)' }}>Searching…</div>}
          {!loading && results.length === 0 && (
            <div style={{ padding: 14, fontSize: 13, color: 'var(--reels-muted, #5b6470)' }}>No travellers match “{term}”.</div>
          )}
          {!loading && results.map(u => (
            <div role="listitem" key={u.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', borderTop: '1px solid var(--reels-border, #e5e0d8)' }}>
              <div style={{ width: 38, height: 38, borderRadius: '50%', flexShrink: 0, overflow: 'hidden', background: B.forest, color: 'white', display: 'grid', placeItems: 'center', fontWeight: 700 }}>
                {u.avatar ? <img src={u.avatar} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (u.name || u.username || '?')[0].toUpperCase()}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--reels-fg, #0f1923)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{u.name}</div>
                <div style={{ fontSize: 12, color: 'var(--reels-muted, #5b6470)' }}>@{u.username} · {u.followersCount || 0} followers</div>
              </div>
              <button type="button" disabled={busyId === u.id} onClick={() => toggleFollow(u)}
                style={{ padding: '7px 14px', borderRadius: 50, border: u.isFollowing ? '1px solid var(--reels-border, #e5e0d8)' : 'none', background: u.isFollowing ? 'transparent' : B.forest, color: u.isFollowing ? 'var(--reels-fg, #0f1923)' : 'white', fontSize: 12, fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}>
                {u.isFollowing ? 'Following' : 'Follow'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
